export default __webpack_public_path__ + "static/media/5_tutorial_route_planner.be649d51.png";